import { CadNextNotification } from '@mark43/cad-api';

export function getNotificationWithHigherPriority(
    notification1: CadNextNotification,
    notification2: CadNextNotification
): CadNextNotification {
    if (notification1.notificationPriority === 'HIGH') return notification1;
    if (notification2.notificationPriority === 'HIGH') return notification2;
    return notification1;
}
